class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    if (this.input) {
      this.input.addEventListener('input', this.onChange.bind(this));
      // Listen for form reset event
      if (this.input.form) {
        this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      }
    }
  }

  onChange() {
    this.updateResetButtonVisibility();
  }

  onFormReset(event) {
    // Native form reset already clears the input, but we ensure it's cleared
    // and update the reset button visibility
    if (this.input) {
      // Don't manually set value - let native reset handle it to avoid conflicts
      // Just update visibility after a brief delay to ensure native reset completes
      setTimeout(() => {
        this.updateResetButtonVisibility();
      }, 0);
    }
  }

  shouldResetForm() {
    // Check if form should be reset (not prevented by event)
    return true;
  }

  updateResetButtonVisibility() {
    if (!this.input) return;
    
    const resetButton = this.input.form?.querySelector('.reset__button');
    if (resetButton) {
      const hasValue = this.input.value.trim().length > 0;
      if (hasValue) {
        resetButton.classList.remove('hidden');
      } else {
        resetButton.classList.add('hidden');
      }
    }
  }
}

customElements.define('search-form', SearchForm);
